export const DOMINICA_COUNTRY_ID = "I2EwGfz6MxHZiUm5lpab"
export const dominicaCountryCode = "dm"
export const usCountryCode = "us"
export const ukCountryCode = 'gb'
export const usaCountryId = '--united-states-of-america--'